<template>
    <div>
        <password-input v-model="password" placeholder="Enter your new password"></password-input>
        <div class="d-flex flex-column align-items-start">
            <label :class="['d-block', atLeast10Characters ? 'text-success' : 'text-danger']">
                <i :class="atLeast10Characters ? 'fa fa-check-circle' : 'fa fa-times-circle'"></i>
                At least 10 characters
            </label>
            <label :class="['d-block', atLeast1Uppercase ? 'text-success' : 'text-danger']">
                <i :class="atLeast1Uppercase ? 'fa fa-check-circle' : 'fa fa-times-circle'"></i>
                At least 1 uppercase
            </label>
            <label :class="['d-block', atLeast1Number ? 'text-success' : 'text-danger']">
                <i :class="atLeast1Number ? 'fa fa-check-circle' : 'fa fa-times-circle'"></i>
                At least 1 number
            </label>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
    import PasswordInput from './PasswordInput.vue';

    export default {
        name: 'PasswordInputValidation',
        props: {
            value: String
        },
        data() {
            return {
                password: this.value
            }
        },
        computed: {
            atLeast10Characters() {
                return this.password.length > 9;
            },
            atLeast1Uppercase() {
                return /[A-Z]/.test(this.password);
            },
            atLeast1Number() {
                return /\d/.test(this.password);
            },
            valid() {
                return !!this.atLeast1Number && !!this.atLeast1Uppercase && !!this.atLeast10Characters
            }
        },
        watch: {
            password() {
                this.$emit('input', this.valid ? this.password : '');
            },
            valid() {
                this.$emit('input', this.valid ? this.password : '');
            }
        },
        components: {
            'password-input': PasswordInput
        }
    }
</script>
